import React from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { Admin } from "../admin/Admin";
import { Developer } from "../developer/Developer";
import {
  canEditModule,
  canViewModule,
  getModulePermissions,
  hasAnyModuleView,
  isBookingAdmin,
} from "../../utils/moduleAccess";

const RoleBase = ({ usersession }) => {
  const authState = useSelector((state) => state.auth);
  const modulePermissions = getModulePermissions(authState);

  const isBookingAdminUser = isBookingAdmin(authState);
  const hasProjectAccess = canViewModule(modulePermissions, "project");
  const hasAvailabilityAccess = canViewModule(modulePermissions, "availability");
  const hasBookingViewAccess = canViewModule(modulePermissions, "booking");
  const hasBookingEditAccess = canEditModule(modulePermissions, "booking") && isBookingAdminUser;
  const hasPeopleAccess = canViewModule(modulePermissions, "people");

  const shouldUseAdminShell =
    hasAnyModuleView(modulePermissions, ["project", "availability", "people"]) ||
    hasBookingEditAccess;
  const shouldUseDeveloperShell = hasBookingViewAccess && !shouldUseAdminShell;

  if (shouldUseAdminShell) {
    return (
      <Routes>
        <Route path="/*" element={<Admin usersession={usersession} />} />
      </Routes>
    );
  }

  if (shouldUseDeveloperShell) {
    return (
      <Routes>
        <Route path="/*" element={<Developer usersession={usersession} />} />
      </Routes>
    );
  }

  if (!hasProjectAccess && !hasAvailabilityAccess && !hasBookingViewAccess && !hasPeopleAccess) {
    return <div>User have no module access.</div>;
  }

  return <div>User have no module access.</div>;
};

export default RoleBase;
